/**
 * The carriers a church picks from when it marks an order shipped (ADR 0047 step 2), and the page on each carrier's
 * own site that shows a tracking number. "Other" carriers get no link: the member sees the carrier and the number.
 */
export const CARRIERS = ["USPS", "UPS", "FedEx", "DHL", "Canada Post"] as const;

const PAGES: Record<string, (number: string) => string> = {
  usps: (n) => `https://tools.usps.com/go/TrackConfirmAction?tLabels=${n}`,
  ups: (n) => `https://www.ups.com/track?tracknum=${n}`,
  fedex: (n) => `https://www.fedex.com/fedextrack/?trknbr=${n}`,
  dhl: (n) => `https://www.dhl.com/global-en/home/tracking.html?tracking-id=${n}`,
  "canada post": (n) =>
    `https://www.canadapost-postescanada.ca/track-reperage/en#/search?searchFor=${n}`,
};

/** The carrier's tracking page for a number, or null when the carrier is not one HoW knows or there is no number. */
export function trackingUrl(carrier: string | null, trackingNumber: string | null): string | null {
  if (carrier === null || trackingNumber === null) return null;
  const number = trackingNumber.replace(/\s+/g, "");
  if (number === "") return null;
  const page = PAGES[carrier.trim().toLowerCase()];
  return page === undefined ? null : page(encodeURIComponent(number));
}
